import createLucideIcon from '../createLucideIcon';

const AlignJustify = createLucideIcon('AlignJustifyIcon', [
  ['line', { x1: '3', y1: '6', x2: '21', y2: '6', key: '1tp2lp' }],
  ['line', { x1: '3', y1: '12', x2: '21', y2: '12', key: '1aui40' }],
  ['line', { x1: '3', y1: '18', x2: '21', y2: '18', key: '1sxo76' }],
]);

export default AlignJustify;
